module.exports = __webpack_public_path__ + "img/GPB_top10-2.bbee77c7.png";